<template>
    <section class="content_section">
      <SimpleList v-if="this.isLoaded"
        @updateData="getAll()"
        :defaultCount="defaultCount" 
        :cols="cols"
        :data="poiDB"
        :emptyState="options.Lang.Keine_POI_vorhanden" 
        :buttonText=options.Lang.Neuen_POI_anlegen 
        buttonAction="POI" 
        :hideCols="hideCols"
        :options="options"
        :actions="actions"
        :title=options.Lang.poi
        :serverside="false"
        :wide="100"
        :clean="false">
      </SimpleList>
      <FormPOI @updateData="getAll()" v-if="options.showPOIForm && options.user.loggedIn" :currentFormPOI="options.currentFormPOI" :options="options" :maxId="maxId"></FormPOI>
    </section>
  </template>
  <script>
  
  const toLower = text => {
    if (text !== null) {
      return text.toString().toLowerCase()
    } else {
      return "";
    }
  }
  
  import SimpleList from "@/components/lists/SimpleList";
  import FormUser from "@/components/dialogs/FormUser";
  import FormPOI from "@/components/dialogs/FormPOI";
  
  export default {
    name: 'users',
    props: {
      options: {
        type: Object,
        required: true
      }
    },
    components: {
      SimpleList,
      FormPOI,
    },
    data() {
      return {
        defaultCount: null,
        poiDB:[],
        hideCols: ['address_line_1','address_line_2','amenities','children','children','interest_categories',
        'internal_remarks','location_pointer','map_center_coordinate','map_selection_height','map_selection_width',
        'map_zoom_level','modified_on','parent','photos','practical_infos','recommendation_category','restriction_by_interest',
        'restriction_by_transportation','status','teaser','zip_code','description'],
        cols: ['id', 'name','city','state','country','coordinate','description',
                'photos','practical_infos','teaser','zip_code'],
        isLoaded: false,
        actions: [
          {
            icon: 'edit_note',
            action: 'editPOI',
            title: this.options.Lang.POI_bearbeiten
          }
        ],
        maxId: 0
      };
    },
    beforeCreate() {
    },
    beforeMount() {
    },
    mounted(){
      if(this.options.currentRoute != 'POI'){
        this.options.showPOIForm = false;
      }
      let self = this;
      self.defaultCount = self.options.defaultCount;
    },
    created() {
      this.getAll();
      
    },
    methods: {
      getAll() {
        let self = this;
        let poiModuleAllowed = this.options.modules.find(module=>module.name === "poi")?.status
        if (poiModuleAllowed) {
          this.doPost({}, "getPois", function (response) {
            if (response.msg === 'success') {
              self.poiDB= response.data.data
              self.getMaxId()
            } else { 
              self.poiDB= []
            }
          });
        } else {
          self.poiDB= []
        }
        self.isLoaded = true;
      },
      getMaxId(){
        let maxId = 0
        this.poiDB.forEach(poi=>{
          let idNumber = poi.id *1
          if (idNumber > maxId) {
            maxId = idNumber
          }
        })
        this.maxId = (maxId + 1).toString()
      }
    }
  };
  </script>